import { useToken } from "../contexts/Token"
import PageNotFound from "../pages/PageNotFound"

const NotLoggedIn = ({ children }) => {
    const token = useToken()

    return !token.access ? <>{children}</> : <PageNotFound />
}

export default NotLoggedIn